import { render, staticRenderFns } from "./aRoomDetailRoom.vue?vue&type=template&id=51e59abe"
import script from "./aRoomDetailRoom.vue?vue&type=script&lang=js"
export * from "./aRoomDetailRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports